import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ERouteLinks } from 'models/route';
import BoxLink from 'components/atoms/BoxLink';
import { StyledTitle } from 'pages/DashboardPage/styles';

const DashboardKeepUpdated = () => (
  <Grid container rowGap="20px">
    <Grid item xs={12}>
      <StyledTitle variant="h4">Keep us updated</StyledTitle>
    </Grid>
    <Grid item xs={12} mb="20px">
      <Typography variant="body1">
        If you hold firearms or shotguns certificate, you need to tell us if your details have
        changed.
      </Typography>
    </Grid>
    <Grid item container xs={12} columnSpacing="20px" rowGap="20px">
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Update your details" />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Add new firearms" />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Sell or dispose of firearms" />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Lost or stolen firearms" />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <BoxLink link={ERouteLinks.Dashboard} textLink="Replace licence" />
      </Grid>
    </Grid>
  </Grid>
);

export { DashboardKeepUpdated };
